import { createFileRoute } from "@tanstack/react-router";

import { BrandLockup, HeroSubtitle } from "@/components/marketing/BrandLockup";
import FaqSection from "@/components/marketing/FaqSection";
import HowItWorks from "@/components/marketing/HowItWorks";
import { marketingHead } from "@/components/marketing/marketingHead";
import MotionExamples from "@/components/marketing/motion/MotionExamples";
import MotionHeroFormats from "@/components/marketing/motion/MotionHeroFormats";
import MotionPreview from "@/components/marketing/motion/MotionPreview";
import MotionReleaseBenefit from "@/components/marketing/motion/MotionReleaseBenefit";
import ProductHero from "@/components/marketing/ProductHero";
import RelatedProducts from "@/components/marketing/RelatedProducts";
import Footer from "@/components/nav/Footer";

const LEDE =
  "Bring your covers to life with moving visuals for Spotify Canvas and Apple Music. Preview your animation, then export the HD format you need.";

export const Route = createFileRoute("/motion-art")({
  component: MotionArtworkPage,
  head: () =>
    marketingHead({
      title: "Motion Artwork for Spotify & Apple Music | Lutely",
      description: LEDE,
      path: "/motion-art",
    }),
});

const FAQ = [
  {
    question: "Can I use my existing cover art?",
    answer:
      "Yes. Start with the square cover art connected to your track and turn it into motion artwork.",
  },
  {
    question: "Can I create a Spotify Canvas?",
    answer:
      "Yes. Lutely lets you preview and export a vertical version formatted for Spotify Canvas.",
  },
  {
    question: "What Apple Music formats are available?",
    answer:
      "Lutely supports square 1:1 and portrait 3:4 motion artwork formats for Apple Music.",
  },
  {
    question: "Can I try a different animation?",
    answer:
      "Yes. You can create another animation from the same cover art and preview the result before exporting.",
  },
  {
    question: "Will my motion artwork be accepted by Apple Music and Spotify?",
    answer:
      "Lutely handles the animation and export settings with platform requirements in mind. Your original cover art and any changes you make must also meet their artwork and content guidelines. Final acceptance is determined by each platform.",
  },
];

function MotionArtworkPage() {
  return (
    <main className="flex flex-col bg-white">
      <ProductHero
        title={
          <>
            <BrandLockup>Motion Art</BrandLockup>
            <br />
            <HeroSubtitle>
              Animate your
              <br />
              artwork
            </HeroSubtitle>
          </>
        }
        lede={LEDE}
        cta="Animate artwork"
        stage={<MotionHeroFormats />}
        plainStage
        wideStage
      />
      <HowItWorks
        title="How it works"
        kicker={false}
        steps={[
          {
            title: "Choose your cover art",
            body: "Start with the artwork connected to your track or release.",
          },
          {
            title: "Animate & preview",
            body: "Bring your cover to life in one click. Save the result or try another animation for a different look.",
          },
          {
            title: "Export in HD",
            body: "Export the format you need for Spotify Canvas or Apple Music.",
          },
        ]}
      />
      <MotionReleaseBenefit />
      <MotionExamples />
      <MotionPreview />
      <FaqSection items={FAQ} />
      <RelatedProducts current="motion" />
      <Footer />
    </main>
  );
}
